import React from 'react';
import { useStoreActions } from "../../../contexts";
import { Button } from 'seagull';
import { StepPage } from "../../components/StepPage";
import { AgreementTerms } from "../AgreementTerms/AgreementTerms";
import { relationshipModel } from "../../../models";
import { serviceModel } from "../../../models";
import { COBStep, getStepName } from "../ClientOnboarding.utils";
import { useResponsive } from "../../contexts";
import ApproveProposalButton from "../../components/ApproveProposalButton";
export default function ApproveTermsStep(_ref) {
  let {
    isPreview,
    isLastStep,
    relationship,
    selectedBundleID,
    COB_IMPROVEMENTS,
    disabledReason,
    approveAgreementStatus,
    selectedOptionalServices,
    previewStatus,
    onDone,
    onBack,
    approveAgreement
  } = _ref;
  const {
    logBI
  } = useStoreActions();
  const {
    isDesktop
  } = useResponsive();

  const isNextDisabled = (() => {
    if (isPreview) return false;
    const services = relationshipModel.actualServices(relationship, selectedBundleID);
    const hasMandatoryServices = services.some(s => serviceModel.isMandatory(s.participation));
    const hasIncludedServices = hasMandatoryServices || !!selectedOptionalServices.length;
    return !hasIncludedServices;
  })();

  return /*#__PURE__*/React.createElement(StepPage, {
    header: getStepName(COBStep.approveTerms, relationship, COB_IMPROVEMENTS),
    showLearnMore: true,
    relationship: relationship,
    primaryBtn: isLastStep ? /*#__PURE__*/React.createElement(ApproveProposalButton, {
      onDone: approveAgreement,
      previewStatus: previewStatus,
      isDesktop: isDesktop,
      relationship: relationship,
      testid: (relationship.isSample ? 'test-agreement-' : '') + 'step2-next-btn',
      disabled: !!disabledReason || isPreview || approveAgreementStatus === 'loading'
    }) : /*#__PURE__*/React.createElement(Button, {
      "data-testid": (relationship.isSample ? 'test-agreement-' : '') + 'step2-next-btn',
      disabled: !COB_IMPROVEMENTS && isNextDisabled,
      onClick: () => {
        !isPreview && logBI(10822);
        onDone();
      }
    }, COB_IMPROVEMENTS ? 'Add payment method' : 'Approve terms'),
    disabledReason: disabledReason,
    showError: !COB_IMPROVEMENTS && isNextDisabled,
    errorTestid: "step2-next-error",
    errorMessage: COB_IMPROVEMENTS ? '' : 'It is required to select at least one service',
    onBackBtnClick: onBack,
    backBtnTestid: (relationship.isSample ? 'test-agreement-' : '') + 'step2-back-btn',
    testid: "approve-terms-step"
  }, /*#__PURE__*/React.createElement(AgreementTerms, {
    relationship: relationship,
    selectedBundleID: selectedBundleID,
    selectedOptionalServices: selectedOptionalServices
  }));
}